import { useEffect, useState } from "react";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { showToast } from "../../../../components/custom/custom-toast";
import { DetailRow } from "../../../../components/custom/detail-row";
import ImageCustom from "../../../../components/custom/image-custom";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { IconEllipse, IconUserDefault } from "../../../../components/icons/icon-group";
import { STATUS } from "../../../../constants/status";
import { useFetchData } from "../../../../hooks/useFetch";
import { DetailBrandResponse } from "../../../../models/response/brand-response";
import { API_BRANDS_ROUTER } from "../../../../services/api-config";

interface BrandDetailProps {
  brandId: string;
  isOpenDetail: boolean;
  setIsOpenDetail: (value: boolean) => void;
}

export const BrandDetail = ({ brandId, isOpenDetail, setIsOpenDetail }: BrandDetailProps) => {
  const [dataDetail, setDataDetail] = useState<DetailBrandResponse>(new DetailBrandResponse());
  const [avatar, setAvatar] = useState<string>("");

  const { request: fetchDataDetail, baseResponse: responsesDetail } = useFetchData.Get<DetailBrandResponse>();

  useEffect(() => {
    if (!isOpenDetail) return
    if (brandId != "") {
      fetchDataDetail({
        endPoint: API_BRANDS_ROUTER.API_DETAIL_BRAND(brandId),
      });
    }
  }, [brandId, isOpenDetail]);

  useEffect(() => {
    if (!responsesDetail) return;
    if (responsesDetail.status === 200) {
      setAvatar(responsesDetail.data.avatar);
      setDataDetail(responsesDetail.data);
    } else {
      showToast({ message: responsesDetail.message, type: "error" });
    }
  }, [responsesDetail]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col  gap-3">


        <div className="flex flex-wrap items-start gap-4">
          {/* BRAND */}
          <div className="w-full bg-white p-4 pt-0 rounded-md">
            <div className="font-bold text-gray-600 py-2">* Thương hiệu:</div>

            <div className="flex flex-col gap-2">
              <DetailRow label="Tên thương hiệu:" value={dataDetail?.brand_name} />
              <DetailRow label="Tên công ty:" value={dataDetail?.identifier_name} />
            </div>
          </div>

          {/* ACCOUNT */}
          <div className="w-full bg-white p-4 pt-0 rounded-md">
            <div className="font-bold text-gray-600 py-2">* Tài khoản:</div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-col items-center justify-center w-full relative mb-3">
                <span className="w-24 h-24 relative">
                  <ImageCustom
                    url={`${avatar || IconUserDefault}`}
                    isLocal={false}
                    className="w-24 h-24 rounded-full overflow-hidden object-cover"
                  />
                  <IconEllipse className="w-24 h-24 absolute inset-0 flex items-center justify-center" />
                </span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <DetailRow label="Tên nhân viên quản trị:" value={dataDetail?.name} />
                <DetailRow label="Tên đăng nhập:" value={dataDetail?.username} />
                <DetailRow label="Ngày sinh:" value={dataDetail?.birthday} />
                <DetailRow label="Giới tính:" value={dataDetail?.gender === STATUS.ACTIVE ? "Nam" : "Nữ"} />
                <DetailRow label="Số điện thoại:" value={dataDetail?.phone} />
                <DetailRow label="Địa chỉ:" value={dataDetail?.address} />
                <DetailRow label="Ngày bắt đầu làm việc:" value={dataDetail?.joining_date} />
                <DetailRow label="Số CCCD:" value={dataDetail?.id_card_number} />
                <DetailRow label="Ngày tạo:" value={dataDetail?.created_at} />
                <DetailRow label="Ngày cập nhật:" value={dataDetail?.updated_at} />
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  };
  const footerModal = () => {
    return (
      <ButtonCustom
        type="button"
        text="Hủy"
        onClick={() => {
          setIsOpenDetail(false);
        }}
        className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
      />
    );
  };

  return (
    <ModalCustom
      isOpen={isOpenDetail}
      setIsOpen={setIsOpenDetail}
      titleModal="Chi tiết thương hiệu"
      bodyModal={bodyModal()}
      footerModal={footerModal()}
      modalSize="xl"
    />
  );
};
